export const BUSINESS = {
  name: "Croudace Pizza & Burger",
  phoneDisplay: "02 4072 2788",
  phoneHref: "tel:+61240722788",
  email: "croudacepizzaandburger@gmail.com",
  address: "20 Lookout Road, New Lambton Heights NSW 2305",
  hours: [
    { day: "Monday", time: "7:00 AM – 8:00 PM" },
    { day: "Tuesday", time: "7:00 AM – 8:00 PM" },
    { day: "Wednesday", time: "7:00 AM – 8:00 PM" },
    { day: "Thursday", time: "7:00 AM – 8:00 PM" },
    { day: "Friday", time: "7:00 AM – 8:00 PM" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" },
  ],
  socials: [
    { id: "facebook", label: "Facebook", href: "https://www.facebook.com/share/18TuUFk9po/?mibextid=wwXIfr" },
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/croudacepizzaandburger" },
    { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@croudace.pizza.an" },
  ],
};

const MAPS_QUERY = "Croudace Tea & Coffee House, 20 Lookout Road, New Lambton Heights NSW 2305";
export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(MAPS_QUERY)}&output=embed`;
export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(MAPS_QUERY)}`;

export const IMAGES = {
  heroPizza: "https://images.pexels.com/photos/34413636/pexels-photo-34413636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  burger: "https://images.pexels.com/photos/18987002/pexels-photo-18987002.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chef: "https://images.pexels.com/photos/24357593/pexels-photo-24357593.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fries: "https://images.unsplash.com/photo-1630431341973-02e1b662ec35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxmcmVuY2glMjBmcmllcyUyMGRhcmt8ZW58MHx8fHwxNzg3NDQxMTE0fDA&ixlib=rb-4.1.0&q=85",
  slice: "https://images.pexels.com/photos/31587831/pexels-photo-31587831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  woodfire: "https://images.unsplash.com/photo-1635194983592-73b79bae1213?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHx3b29kZmlyZWQlMjBwaXp6YSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NzQ0MTExNHww&ixlib=rb-4.1.0&q=85",
  drinks: "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?auto=format&fit=crop&w=940&q=80",
  dough: "https://images.pexels.com/photos/28945109/pexels-photo-28945109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  coffee: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=940&q=80",
  breakfast: "https://images.unsplash.com/photo-1525351484163-7529414344d8?auto=format&fit=crop&w=940&q=80",
  salad: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=940&q=80",
  toast: "https://images.unsplash.com/photo-1528735602780-2552fd46c7af?auto=format&fit=crop&w=940&q=80",
};

export const MENU = [
  {
    id: "burgers",
    label: "Burgers",
    note: "Made to order with fresh mince & fresh chicken",
    image: IMAGES.burger,
    items: [
      { name: "Cheeseburger", desc: "Smashed beef, American cheese, lettuce, tomato, caramelised onion, tomato sauce & mustard", price: "15.90" },
      { name: "Double Smash Burger", desc: "Two smashed beef patties, double American cheese, fresh jalapeños, caramelised onion & house burger sauce", price: "17.90" },
      { name: "Grilled Chicken Deluxe", desc: "Grilled chicken, cheese, lettuce, tomato, onion, pickles & aioli", price: "16.90" },
      { name: "Peri-Peri Chicken Burger", desc: "Grilled chicken, cheese, lettuce & tomato with peri-peri mayo", price: "17.90", tags: ["HOT"] },
      { name: "Fried Chicken Burger", desc: "Fresh fried chicken, onion, tomato, lettuce, pickles, cheese & house sauce", price: "17.90" },
      { name: "Butter Chicken Burger", desc: "Fried chicken, butter chicken sauce, cheese, lettuce, onion & mint mayo", price: "17.90" },
      { name: "Veggie Patty Burger", desc: "Veggie patty, cheese, lettuce, tomato, onion & house sauce", price: "15.90", tags: ["V"] },
    ],
  },
  {
    id: "coffee",
    label: "Coffee & Tea",
    note: "Small · Medium · Large",
    image: IMAGES.coffee,
    items: [
      { name: "Espresso", desc: "Single shot, short & strong", price: "4.00" },
      { name: "Babycino", desc: "With marshmallow", price: "2.00" },
      { name: "Piccolo", desc: "Small, strong & smooth", price: "4.50" },
      { name: "Latte", desc: "Available in 3 sizes", price: "4.60", variants: [{ label: "Small", price: "4.60" }, { label: "Medium", price: "5.20" }, { label: "Large", price: "6.00" }] },
      { name: "Long Black", desc: "Available in 3 sizes", price: "4.60", variants: [{ label: "Small", price: "4.60" }, { label: "Medium", price: "5.20" }, { label: "Large", price: "6.00" }] },
      { name: "Macchiato", desc: "Available in 3 sizes", price: "4.60", variants: [{ label: "Small", price: "4.60" }, { label: "Medium", price: "5.20" }, { label: "Large", price: "6.00" }] },
      { name: "Flat White", desc: "Available in 3 sizes", price: "4.60", variants: [{ label: "Small", price: "4.60" }, { label: "Medium", price: "5.20" }, { label: "Large", price: "6.00" }] },
      { name: "Cappuccino", desc: "Available in 3 sizes", price: "4.60", variants: [{ label: "Small", price: "4.60" }, { label: "Medium", price: "5.20" }, { label: "Large", price: "6.00" }] },
      { name: "Hot Chocolate", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Chai Latte", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Mocha", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Dirty Chai", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Matcha Latte", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Turmeric Latte", desc: "Available in 3 sizes", price: "5.10", variants: [{ label: "Small", price: "5.10" }, { label: "Medium", price: "5.70" }, { label: "Large", price: "6.50" }] },
      { name: "Pot of Tea", desc: "English Breakfast, Earl Grey, Peppermint, Chamomile or Green Tea", price: "5.50" },
    ],
  },
  {
    id: "breakfast",
    label: "Breakfast",
    note: "Until 11:30 AM",
    image: IMAGES.breakfast,
    items: [
      { name: "Bacon & Egg Roll", desc: "Bacon, egg, cheese & your choice of tomato sauce, BBQ sauce or aioli", price: "10.90" },
      { name: "Double Bacon & Egg Roll", desc: "Double bacon, egg, cheese & your choice of sauce", price: "13.90" },
      { name: "Breakkie Burger", desc: "Bacon, egg, cheese, hash brown, avocado & your choice of sauce", price: "15.90" },
      { name: "Bacon & Eggs on Toast", desc: "Bacon & eggs served on toast with your choice of sauce", price: "13.50" },
      { name: "Scrambled Eggs on Toast", desc: "Creamy scrambled eggs on toast with your choice of sauce", price: "10.90" },
      { name: "Smashed Avo Delight", desc: "Smashed avocado, feta, onion, cherry tomato & balsamic glaze on toast with hash brown", price: "17.90", tags: ["V"] },
    ],
  },
  {
    id: "pinsas",
    label: "Roman-Style Pizza",
    note: "Available after 2 PM",
    image: IMAGES.heroPizza,
    items: [
      { name: "Margherita", desc: "Tomato sauce, mozzarella, cherry tomato, fresh basil & olive oil", price: "16.99", tags: ["V"] },
      { name: "Pepperoni", desc: "Tomato sauce, mozzarella, pepperoni & oregano", price: "17.99" },
      { name: "Hawaiian", desc: "Tomato sauce, mozzarella, smoked ham & pineapple", price: "17.99" },
      { name: "BBQ Chicken & Bacon", desc: "Smoky BBQ sauce, mozzarella, roast chicken, bacon & red onion", price: "17.99" },
      { name: "Butter Chicken", desc: "Butter chicken sauce, mozzarella, butter chicken, capsicum, red onion & mint mayo", price: "17.99" },
      { name: "Tandoori Chicken", desc: "Tandoori sauce, mozzarella, tandoori chicken, capsicum, red onion & mint mayo", price: "17.99", tags: ["HOT"] },
      { name: "Peri-Peri Chicken", desc: "Peri peri sauce, mozzarella, peri peri chicken, capsicum, red onion & peri peri mayo", price: "17.99", tags: ["HOT"] },
    ],
  },
  {
    id: "lunch",
    label: "Lunch",
    note: "Served with chips & salad",
    image: IMAGES.chef,
    items: [
      { name: "Chicken Schnitzel", desc: "Served with chips & salad", price: "19.90" },
      { name: "Fish & Chips", desc: "Served with chips & salad", price: "19.90" },
      { name: "Lasagne", desc: "Served with chips & salad", price: "19.90" },
      { name: "Quiche", desc: "Served with chips & salad", price: "19.90" },
    ],
  },
  {
    id: "salads",
    label: "Salads",
    note: "Fresh & generous",
    image: IMAGES.salad,
    items: [
      { name: "Thai Chicken Salad", desc: "Grilled chicken, mixed greens, carrot, capsicum, cucumber, red onion, cherry tomato, glass noodles, peanuts & Thai dressing", price: "16.90" },
      { name: "Pumpkin and Feta Salad", desc: "Pumpkin, beetroot, feta, walnuts, mixed greens, red onion & balsamic dressing", price: "16.90" },
      { name: "Caesar Salad", desc: "Grilled chicken, cos lettuce, crispy bacon, parmesan, croutons & Caesar dressing", price: "16.90" },
    ],
  },
  {
    id: "loaded-fries",
    label: "Loaded Fries",
    note: "Seasoned fries, fully loaded",
    image: IMAGES.fries,
    items: [
      { name: "Chicken & Bacon Loaded Fries", desc: "Chicken, crispy bacon, melted cheese, house sauce, fresh jalapeño & spring onion", price: "16.90" },
      { name: "Smashed Beef Loaded Fries", desc: "Smashed beef, melted cheese, house sauce, fresh jalapeño & spring onion", price: "16.90" },
      { name: "Cheesy Loaded Fries", desc: "Melted cheese, house sauce, fresh jalapeño & spring onion", price: "13.90" },
    ],
  },
  {
    id: "sides",
    label: "Sides & Dips",
    note: "The perfect plus-one",
    image: IMAGES.slice,
    items: [
      { name: "Hot Chips — Regular", desc: "Crispy hot chips", price: "5.50" },
      { name: "Hot Chips — Large", desc: "Crispy hot chips", price: "7.50" },
      { name: "Onion Rings", desc: "Golden crispy onion rings", price: "8.90" },
      { name: "Mozzarella Sticks", desc: "Crumbed mozzarella, melted inside", price: "9.90" },
      { name: "Home Made Garlic Bread", desc: "Made fresh in-house", price: "7.50" },
      { name: "Home Made Cheesy Garlic Bread", desc: "Made fresh in-house, loaded with cheese", price: "8.90" },
      { name: "Dips", desc: "Tomato, BBQ, sweet chilli, peri peri mayo, aioli or gravy", price: "1.50" },
    ],
  },
  {
    id: "toasties",
    label: "Toasties & Sweets",
    note: "Toasted fresh",
    image: IMAGES.toast,
    items: [
      { name: "Cheese & Tomato Toastie", desc: "Toasted golden", price: "7.90" },
      { name: "Chicken & Cheese Toastie", desc: "Toasted golden", price: "9.90" },
      { name: "Ham, Cheese & Tomato Toastie", desc: "Toasted golden", price: "10.90" },
      { name: "Cinnamon Toast", desc: "Warm & sweet", price: "7.00" },
      { name: "Raisin Toast", desc: "Warm & sweet", price: "7.00" },
      { name: "Banana Bread", desc: "Toasted, with butter", price: "7.50" },
      { name: "Pear & Raspberry Bread", desc: "Toasted, with butter", price: "7.90" },
      { name: "Banana & Walnut Bread", desc: "Toasted, with butter", price: "7.90" },
    ],
  },
  {
    id: "cold-drinks",
    label: "Cold Drinks",
    note: "Iced, shaken & blended",
    image: IMAGES.drinks,
    items: [
      { name: "Iced Latte", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Iced Coffee", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Iced Chocolate", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Iced Mocha", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Iced Chai Latte", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Iced Dirty Chai", desc: "Regular or large", price: "8.00", variants: [{ label: "Regular", price: "8.00" }, { label: "Large", price: "9.00" }] },
      { name: "Milkshake", desc: "Chocolate, strawberry, caramel, vanilla or banana · dairy free on request", price: "8.00", variants: [{ label: "Small", price: "8.00" }, { label: "Large", price: "9.00" }, { label: "Small Thickshake", price: "10.00" }, { label: "Large Thickshake", price: "11.00" }] },
      { name: "Smoothie", desc: "Mixed berry, banana, mango or strawberry · dairy free on request", price: "10.00" },
    ],
  },
  {
    id: "extras",
    label: "Make It Yours",
    note: "Coffee extras · $1 each",
    image: IMAGES.coffee,
    items: [
      { name: "Extra Shot", desc: "Add to any coffee", price: "1.00" },
      { name: "Flavoured Syrup", desc: "Caramel, vanilla, hazelnut or butterscotch", price: "1.00" },
      { name: "Alternative Milk", desc: "Almond, soy, lactose free or oat", price: "1.00" },
      { name: "Chai Powder", desc: "Add to any drink", price: "1.00" },
      { name: "Chocolate", desc: "Add to any drink", price: "1.00" },
      { name: "Decaf", desc: "Any coffee, decaf", price: "1.00" },
    ],
  },
];

const PICKUP_HOURS = { 0: null, 1: [7, 20], 2: [7, 20], 3: [7, 20], 4: [7, 20], 5: [7, 20], 6: null };

export function getPickupSlots() {
  const now = new Date();
  const range = PICKUP_HOURS[now.getDay()];
  if (!range) return [];
  const [openH, closeH] = range;
  const closeMins = closeH * 60 - 15;
  let startMins = now.getHours() * 60 + now.getMinutes() + 30;
  startMins = Math.max(startMins, openH * 60);
  startMins = Math.ceil(startMins / 15) * 15;
  const slots = [];
  for (let m = startMins; m <= closeMins; m += 15) {
    const h24 = Math.floor(m / 60) % 24;
    const ampm = h24 >= 12 ? "PM" : "AM";
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
    slots.push(`${h12}:${String(m % 60).padStart(2, "0")} ${ampm}`);
  }
  return slots;
}

const SAUCE_CHOICES = ["Tomato Sauce", "BBQ Sauce", "Aioli"];
const TEA_VARIETIES = ["English Breakfast", "Earl Grey", "Peppermint", "Chamomile", "Green Tea"];
const MILKSHAKE_FLAVOURS = ["Chocolate", "Strawberry", "Caramel", "Vanilla", "Banana"];
const SMOOTHIE_FLAVOURS = ["Mixed Berry", "Banana", "Mango", "Strawberry"];
const DIP_OPTIONS = ["Tomato Sauce", "Barbecue Sauce", "Sweet Chilli", "Peri Peri Mayo", "Aioli", "Gravy"];

const HINT = "Anything else we should know? (optional)";

export const DEAL_CHOICES = {
  "Bacon & Egg Roll": { selections: [{ label: "Sauce", options: SAUCE_CHOICES }], hint: HINT },
  "Double Bacon & Egg Roll": { selections: [{ label: "Sauce", options: SAUCE_CHOICES }], hint: HINT },
  "Breakkie Burger": { selections: [{ label: "Sauce", options: SAUCE_CHOICES }], hint: HINT },
  "Bacon & Eggs on Toast": { selections: [{ label: "Sauce", options: SAUCE_CHOICES }], hint: HINT },
  "Scrambled Eggs on Toast": { selections: [{ label: "Sauce", options: SAUCE_CHOICES }], hint: HINT },
  "Pot of Tea": { selections: [{ label: "Tea", options: TEA_VARIETIES }], hint: HINT },
  "Milkshake": { selections: [{ label: "Flavour", options: MILKSHAKE_FLAVOURS }], hint: HINT },
  "Smoothie": { selections: [{ label: "Flavour", options: SMOOTHIE_FLAVOURS }], hint: HINT },
  "Flavoured Syrup": { selections: [{ label: "Syrup", options: ["Caramel", "Vanilla", "Hazelnut", "Butterscotch"] }], hint: HINT },
  "Alternative Milk": { selections: [{ label: "Milk", options: ["Almond", "Soy", "Lactose Free", "Oat"] }], hint: HINT },
  "Dips": { selections: [{ label: "Sauce", options: DIP_OPTIONS }], hint: HINT },
};

const COFFEE_ADDONS = [
  {
    key: "milk",
    label: "Milk (+$1)",
    multi: false,
    options: [
      { name: "Almond", price: 1 },
      { name: "Soy", price: 1 },
      { name: "Oat", price: 1 },
      { name: "Lactose Free", price: 1 },
    ],
  },
  {
    key: "extras",
    label: "Extras (+$1 each)",
    multi: true,
    options: [
      { name: "Extra Shot", price: 1 },
      { name: "Decaf", price: 1 },
    ],
  },
  {
    key: "syrup",
    label: "Flavours (+$1 each)",
    multi: true,
    options: [
      { name: "Butterscotch", price: 1 },
      { name: "Caramel", price: 1 },
      { name: "Hazelnut", price: 1 },
      { name: "Vanilla", price: 1 },
    ],
  },
];

MENU.find((c) => c.id === "coffee").items.forEach((i) => {
  if (["Pot of Tea", "Babycino"].includes(i.name)) return;
  DEAL_CHOICES[i.name] = { selections: [], addons: COFFEE_ADDONS, hint: HINT };
});
